import photoCollectorService from '../services/photoCollectorService';

/**
 * The shop is done with some customer files from the Photo Booth — it printed them, or downloaded what it made from them.
 * A file the CUSTOMER marked private (the lock on the upload page) is deleted from the booth for good; any other stays there for
 * its normal expiry so it can be used again. Call it from the place that prints / downloads, with the booth ids that went into it.
 *
 * Never throws (a failed call must not spoil the print) and says nothing when there was nothing private. → the ids that were deleted.
 */
export async function reportBoothDone(ids) {
    const list = [...new Set((ids || []).filter(Boolean))];
    if (!list.length) return [];
    try {
        const res = await photoCollectorService.done(list);
        return res?.data?.deleted || [];
    } catch {
        return [];
    }
}
